import { useRecordContext } from "react-admin";
import { Student } from "../providers/studentsProvider";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import UndoIcon from "@mui/icons-material/Undo";
import { reportError } from "../backoffice.utils";
import { LocalizedError } from "../utils/LocalizedError";
import { Invoice, invoicesProvider } from "../providers/invoicesProvider";

export const BookOutButton = ({ onClick }: { onClick: (student: Student, invoices: Array<Invoice>) => void }) => {
  const student = useRecordContext<Student>();
  const [loadingInvoices, setLoadingInvoices] = useState(false);

  const loadInvoicesAndOpenDialog = async (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setLoadingInvoices(true);
    try {
      const { data: invoices } = await invoicesProvider.getList("b2cInvoices", {
        filter: { studentId: student.id },
        pagination: { page: 1, perPage: 9999 },
        sort: { field: "created_at", order: "ASC" },
      });
      const filteredInvoices = invoices.filter(({ status }) => status === "UNPAID" || status === "PAYMENT_REVOKED");
      if (filteredInvoices.length === 0) {
        showErrorToast("Keine Rechnung zum Ausbuchen gefunden.");
        return;
      }
      onClick(student, filteredInvoices);
    } catch (error) {
      if (error instanceof LocalizedError) {
        showErrorToast(error.message);
      } else {
        reportError("Failed to retrieve invoices", error);
        showErrorToast("Fehler beim Laden der Rechnungen");
      }
    } finally {
      setLoadingInvoices(false);
    }
  };

  return (
    <>
      <LoadingButton
        sx={{ px: 2 }}
        loading={loadingInvoices}
        startIcon={<UndoIcon />}
        disabled={!student}
        onClick={loadInvoicesAndOpenDialog}
      >
        {"Ausbuchen"}
      </LoadingButton>
    </>
  );
};
